<template>
    <div class="main-body">
        <div class="header">
            盘点单
        </div>
        <div class="out">

            <div class="search2">

                <el-button size="mini" type="primary" @click.native="showForm">物品添加</el-button>
                <div style="clear: both;"></div>
            </div>


          <el-table class="table" size="mini"
                        :data="waresInfo"
                        :height="th"
                        style="width: 100%" v-loading="tableLoading">

                        <el-table-column prop="name" label="物品名称"></el-table-column>

                        <el-table-column prop="supplierName" label="供应商"></el-table-column>

                        <el-table-column prop="waresTypeName" label="物品类型"></el-table-column>

                        <el-table-column prop="inventoryCount" label="盘点数量"></el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="small" @click.native.prevent="editRow(scope.$index, waresInfo)">修改数量</el-button>
                                <el-button type="primary" size="small" @click.native.prevent="deleteRow(scope.$index,waresInfo)">删除</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

            <div class="footer" style="display: flex;justify-content: center;padding-top: 5px ;">
                <el-button :loading="loading" type="primary" size="mini" @click="confirm()">提交</el-button>
            </div>

        </div>

        <SelectWares ref="mySelectWares" v-show="showModalSelectWares" v-on:closeSelectWares="closeSelectWares" v-on:getWares='getWares'></SelectWares>

    </div>
</template>

<script>
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode,setTokenBykey,removeTokenBykey,getTokenBykey} from "@/utils/auth";
    import SelectWares from "./SelectWares";

    export default {
        name: "Page",
        data(){
            return{
                tableLoading:false,
                loading:false,
                disabledAdd:true,
                menuButtonList:null,
                showModalAdd:false,
                showModalEdit:false,
                showModalSelectWares:false,
                tableData:null,
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                waresInfo:[],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    waresArr:null
                },

            }
        },
        components:{
            SelectWares
        },
        created(){
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            handleEdit(index, row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            editRow(index,rows){
                this.$prompt('请输入此物品盘点数量', '商品数量', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:/^(0|\+?[1-9][0-9]*)$/,
                    inputErrorMessage:'添加数量为正整数',
                    inputType:'number'
                }).then(({ value }) => {
                    rows[index].inventoryCount=value
                    this.waresInfo=rows
                    setTokenBykey(getStaffCode()+'waresInfoInventory',this.waresInfo)
                    this.getList()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            closeSelectWares:function(){
                this.showModalSelectWares = !this.showModalSelectWares;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
                setTokenBykey(getStaffCode()+'waresInfoInventory',this.waresInfo)
            },
            showForm(){
                var list=this.waresInfo
                this.$refs.mySelectWares.init(list);
                this.closeSelectWares()
            },
            getWares(row){
                this.waresInfo.push(row)
                setTokenBykey(getStaffCode()+'waresInfoInventory',this.waresInfo)
            },
            confirm(){
                if(this.waresInfo.length>0){

                    this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                    this.addForm.waresArr=this.waresInfo;
                    this.$axios({
                        method: 'post',
                        url: this.$shopUrl+"Inventory/Add",
                        data: this.addForm
                    }).then(
                        (response) => {
                            this.loading = false;
                            if (response.data.error == 0) {
                                removeTokenBykey(getStaffCode()+'waresInfoInventory')
                                this.getList()
                            }else if(response.data.error == 1){
                                this.$message({type: 'info', message: response.data.message});
                            }
                        }
                    )

                }else{
                    this.$message({
                        type: 'info',
                        message: '请选择出库物品'
                    });
                }
            },
            getList(){
                this.tableLoading=true;
                var info=getTokenBykey(getStaffCode()+'waresInfoInventory');
                this.tableLoading=false;
                if(info){
                    this.waresInfo=JSON.parse(info)
                }else{
                    this.waresInfo=[]
                }
            },


        }

    }
</script>

<style scoped>

</style>
